// styles
import '../styles/main.scss';

// theming
import { setTheme } from './theme-manager';
import theme from './themes/theme-default';

setTheme(theme);
